module.exports = __webpack_public_path__ + "static/media/hq.0b6bef2c.jpg";